import clsx from "clsx";
import { useMemo, useRef, useState } from "react";
import utils from "../../../../business/helper/Utils";
import { useClickOutside } from "../../../../hooks/useClickOutside";

const formattedNumber = (num) => {
  return num.toString().padStart(2, "0"); // Ensure the number is at least 2 digits
};

const Time = ({ header, value, onChange, icon }) => {
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [time, setTime] = useState({ hours: value, minutes: "00" });
  const selectRef = useRef(null);

  const hours = useMemo(
    () => Array.from({ length: 24 }, (_, index) => formattedNumber(index)),
    []
  );

  const minutes = useMemo(
    () => Array.from({ length: 60 }, (_, index) => formattedNumber(index)),
    []
  );

  useClickOutside(selectRef, () => setIsOptionsOpen(false));

  const handleSelect = (type, value) => {
    let newTime = {
      ...time,
    };
    newTime[type] = value;
    setTime(newTime);
    onChange(`${newTime.hours}:${newTime.minutes}`);
  };

  return (
    <>
      <div className="relative flex flex-col gap-1.5 max-w-[200px] cursor-pointer">
        <p className="font-semibold">{header}</p>
        <div
          ref={selectRef}
          className="border border-dimgray-400 rounded-lg py-2.5 px-3"
          onClick={() => setIsOptionsOpen((prev) => !prev)}
        >
          <div className="w-full focus:outline-none flex items-center justify-between">
            {time.hours}:{time.minutes}
            {icon || (
              <svg
                className={clsx(
                  "w-4 h-4 transform transition-transform",
                  isOptionsOpen && "rotate-180"
                )}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            )}
          </div>

          {isOptionsOpen && (
            <div className="absolute top-20 left-0 w-fit flex justify-center rounded-lg shadow-select z-30 bg-white overflow-hidden">
              <div className="max-h-64 overflow-auto scrollbar-invisible">
                {hours.map((hour) => (
                  <div
                    className={clsx(
                      "cursor-pointer px-6 py-1 text-center w-fit leading-6 hover:bg-whitesmoke-400 first:rounded-tl-lg last:rounded-bl-lg",
                      {
                        "bg-whitesmoke-500": hour === time.hours,
                      }
                    )}
                    onClick={() => {
                      setIsOptionsOpen(false);
                      handleSelect("hours", hour);
                    }}
                  >
                    {hour}
                  </div>
                ))}
              </div>

              <div className="max-h-64 overflow-auto scrollbar-invisible">
                {minutes.map((minutes) => (
                  <div
                    className={clsx(
                      "cursor-pointer px-6 py-1 text-center w-fit leading-6 hover:bg-whitesmoke-400 first:rounded-tr-lg last:rounded-br-lg",
                      {
                        "bg-whitesmoke-500": minutes === time.minutes,
                      }
                    )}
                    onClick={() => {
                      handleSelect("minutes", minutes);
                    }}
                  >
                    {minutes}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Time;
